import { useState } from 'react';
import './AirlineTable.css';


function AirlineTable({ data }) {
  const [hoveredCol, setHoveredCol] = useState(null);

  if (!data || Object.keys(data).length === 0) {
    return (
        <></> 
    );
  }

const order = ["AC", "TK", "TS", "WS", "CM"];

const chartData = Object.entries(data || {})
  .map(([airline, count]) => ({
    name: airline,
    value: count
  }))
  .sort((a, b) => {
    const aIndex = order.indexOf(a.name);
    const bIndex = order.indexOf(b.name);

    return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
  });

const visibleChartData = chartData.filter((item) => item.name);


  return (
    <>
         <div className='detailed-breakdown airline-table table-horizontal-wrap d-flex'>
          <div className='table-header-box'>
            <table className="detailedBreakdownTable">
              <tbody>
                <tr>
                  <th>Airline Code</th>
                </tr>
                <tr>
                  <th>Tickets Sold</th>
                </tr>
                <tr>
                  <th>Percentage</th>
                </tr>
              </tbody>
            </table>
          </div>

            <div className='table-body-box'>
              <table className="detailedBreakdownTable">
                <thead>
                  <tr>                  
                    {visibleChartData.map((item, index) => (
                      <th key={index} className={hoveredCol === index ? 'highlight' : ''}
                      onMouseEnter={() => setHoveredCol(index)} onMouseLeave={() => setHoveredCol(null)}>
                        {item.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {/* <td className="row-header">Tickets Sold</td> */}
                    {visibleChartData.map((item, index) => (
                      <td key={index} className={hoveredCol === index ? 'highlight' : ''}
                        onMouseEnter={() => setHoveredCol(index)} onMouseLeave={() => setHoveredCol(null)}>
                        {item.name ? item.value.toLocaleString() : ''}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {/* <td className="row-header">Percentage</td> */}
                    {visibleChartData.map((item, index) => {
                      const total = chartData.reduce((sum, d) => sum + d.value, 0);
                      const percentage = ((item.value / total) * 100).toFixed(2);
                      return (
                        <td key={index} className={hoveredCol === index ? 'highlight' : ''}
                          onMouseEnter={() => setHoveredCol(index)} onMouseLeave={() => setHoveredCol(null)}>
                          {item.name ? `${percentage}%` : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table> 
          </div>
        </div>
    </>
    );
}

export default AirlineTable;
